export default __webpack_public_path__ + "static/B0196-79028b90f3e41e72a0109302b5ab1e9d.png";